var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GlobalLayout',[_c('div',{staticClass:"devicelistofproj"},[_c('div',{staticClass:"device_title"},[_c('span',{staticClass:"title"},[_vm._v("设备")])]),_c('div',{staticClass:"paths"},[_c('router-link',{attrs:{"to":"/control/all/device"}},[_vm._v("所有设备")]),_vm._l((_vm.productList),function(item,index){return _c('router-link',{key:index,attrs:{"to":'/control/all/product/' +
          item.productCode +
          '?companyCode=' +
          item.companyCode +
          '&productCode=' +
          item.productCode}},[_vm._v(_vm._s(item.productName))])})],2),_c('hr',{staticStyle:{"color":"#e5e5e5","opacity":"0.2"}}),_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }